import Vue from 'vue'
import VueAMap from 'vue-amap';
Vue.use(VueAMap)
    VueAMap.initAMapApiLoader({
        key: '0bbbc932d1a50c270d74e735deeda529',
        plugin: [
            'AMap.Geolocation',
            // 'AMap.Autocomplete',
            // 'AMap.PlaceSearch',
            // 'AMap.Scale',
            // 'AMap.OverView',
            // 'AMap.ToolBar',
            // 'AMap.MapType',
            // 'AMap.PolyEditor',
            // 'AMap.CircleEditor',
        ],
        uiVersion: '1.0', // ui库版本，不配置不加载,
        v: '1.4.4'
    });



// WEBPACK FOOTER //
// ./src/lib/amap.js